import clsx from 'clsx';
import React from 'react';
import { CustomListProps } from './CustomList.types';

export const CustomList = ({
  bulletColor = 'blue',
  bulletType = 'bullet',
  listItems = [],
  children = null,
  isGrid,
  listClassNames,
  listItemClassNames,
  listType = 'ul',
}: CustomListProps): JSX.Element => {
  if (!children && !listItems.length) {
    return null;
  }

  const Tag = listType;

  return (
    <Tag
      className={clsx(
        'hds-custom-list',
        `hds-custom-list_${bulletType}-${bulletColor}`,
        {
          'hds-custom-list_grid': isGrid,
        },
        listClassNames
      )}
    >
      {children ??
        listItems.map((child: React.ReactNode, index: number) => (
          <li key={`custom-list-item-${index}`} className={listItemClassNames}>
            {child}
          </li>
        ))}
    </Tag>
  );
};
